import React from 'react';

import ColorPicker from '../../ColorPicker';
import {useWorkspaceSettingsColorPalette} from '../../WorkspaceDrawer/Settings/colorPalette/ColorPalette';

const colorPickerStyles = {
  margin: 0,
  display: 'block',
  height: 16,
  width: 16,
  marginTop: -8,
};

type RowColorPickerProps = {
  customRunColor: string;
  isColorPickerVisible: boolean;
  isRunBaseline: boolean;
  onOpenColorPicker?: () => void;
  onSetCustomRunColor: (color: string) => void;
};

export function RowColorPicker({
  customRunColor,
  isColorPickerVisible,
  isRunBaseline,
  onSetCustomRunColor,
}: RowColorPickerProps) {
  const colorPaletteOption = useWorkspaceSettingsColorPalette();

  if (isRunBaseline || !isColorPickerVisible) {
    return null;
  }

  return (
    <div className="flex shrink-0 items-center w-24 justify-center">
      <ColorPicker
        style={colorPickerStyles}
        invertColorsInDarkMode={false}
        activeColor={customRunColor}
        setColor={onSetCustomRunColor}
        colorPaletteOption={colorPaletteOption}
      />
    </div>
  );
}
